import { ChevronRight, GitBranch, Circle } from 'lucide-react';
import type { AgentSession, AgentStatus } from '@/lib/agents/types';
import { cn } from '@/lib/utils';

interface Props {
  session: AgentSession | undefined;
}

const STATUS_LABEL: Record<AgentStatus, string> = {
  idle: 'Idle',
  thinking: 'Thinking',
  streaming: 'Streaming',
  tool_calling: 'Using tool',
  waiting_for_user: 'Waiting for approval',
  error: 'Error',
  completed: 'Done',
};

const STATUS_COLOR: Record<AgentStatus, string> = {
  idle: 'bg-fg-subtle',
  thinking: 'bg-info animate-pulse-soft',
  streaming: 'bg-info animate-pulse-soft',
  tool_calling: 'bg-accent animate-pulse-soft',
  waiting_for_user: 'bg-warning',
  error: 'bg-danger',
  completed: 'bg-success',
};

export function HeaderBar({ session }: Props) {
  return (
    <header className="flex h-11 shrink-0 items-center gap-2 border-b border-border bg-canvas px-4">
      <div className="flex min-w-0 items-center gap-1.5 text-[13px]">
        <span className="text-fg-muted">Xoro</span>
        <ChevronRight className="h-3.5 w-3.5 text-fg-subtle" />
        <span className="text-fg-muted">
          {(session?.metadata as { project?: string })?.project ?? 'Workspace'}
        </span>
        <ChevronRight className="h-3.5 w-3.5 text-fg-subtle" />
        <span className="truncate font-medium text-fg">{session?.name ?? '—'}</span>
      </div>

      <div className="ml-auto flex items-center gap-3 text-[12px] text-fg-muted">
        <div className="flex items-center gap-1.5">
          <GitBranch className="h-3.5 w-3.5" />
          <span>main</span>
        </div>
        {session && (
          <div className="flex items-center gap-1.5">
            <span className={cn('status-dot', STATUS_COLOR[session.status])} />
            <span>{STATUS_LABEL[session.status]}</span>
          </div>
        )}
        <button
          className="focus-ring flex items-center gap-1 rounded-md border border-border bg-surface px-2 py-1 text-fg-muted hover:text-fg"
          aria-label="Recent activity"
        >
          <Circle className="h-2.5 w-2.5 fill-success text-success" />
          <span>Connected</span>
        </button>
      </div>
    </header>
  );
}
